// this file is generated by update_shopify_store_data.py at 2026-06-22 20:28:56.372962
var courses = [
    {
        "course_id": "25CE8308-5D56-EE11-9987-005056A73D13",
        "course_version": 3,
        "name": "ANA: Psychiatric-Mental Health Nurse Practitioner Certification (PMHNP-BC) PracticeIQ",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\n\r\nYou will review for the PMHNP-BC exam by quizzing yourself on more than 275 practice questions covering the areas of:\r\n\r\nI. Scientific Foundation\r\nII. Advanced Practice Skills\r\nIII. Diagnosis and Treatment\r\nIV. Psychotherapy and Related Theories\r\nV. Ethics, Legal Principles and Cultural Care\r\n\r\nYou may choose to go through the PracticeIQ just once or retake it as many times as you want or need. You have the option to practice with the full question set or by Content Domain area. Access is available through the learning portal 24/7. ANAs certification prep materials are developed and peer-reviewed by subject-matter experts with advanced education and certified in the specialty.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Prepare for the PMHNP-BC&trade; exam based on the ANCC Test Content Outline effective April 28, 2023</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Psychosocial Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                "course_category_name": "Psychiatric Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Behavioral Health Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 23.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];